import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

export default function PointGuide() {
  const [isOpen, setIsOpen] = useState(false);

  const points = [
    { label: '出席（ログイン）', pts: '10pt', icon: FiIcons.FiCheckCircle, color: 'text-green-400' },
    { label: 'ニュースを読む', pts: '3pt', icon: FiIcons.FiBookOpen, color: 'text-blue-400' },
    { label: 'チャレンジ完了', pts: '20pt', icon: FiIcons.FiTarget, color: 'text-red-400' },
    { label: '掲示板投稿', pts: '5〜30pt', icon: FiIcons.FiEdit3, color: 'text-purple-400' },
    { label: 'ガチャプレイ', pts: '3〜30pt', icon: FiIcons.FiPlayCircle, color: 'text-yellow-400' },
  ];

  return (
    <div className="bg-brand-card rounded-xl border border-gray-700 overflow-hidden mb-4">
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className="w-full p-3 flex justify-between items-center bg-brand-card hover:bg-brand-hover transition-colors"
      >
        <span className="text-sm font-bold text-gray-200 flex items-center gap-2">
          <SafeIcon icon={FiIcons.FiInfo} className="text-brand-main" />
          ポイントの貯め方
        </span>
        <motion.div animate={{ rotate: isOpen ? 180 : 0 }}>
          <SafeIcon icon={FiIcons.FiChevronDown} className="text-gray-400" />
        </motion.div>
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div 
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="overflow-hidden"
          >
            <div className="p-3 pt-0 border-t border-gray-700/50">
              <ul className="space-y-2 mt-2">
                {points.map((p, idx) => (
                  <li key={idx} className="flex justify-between items-center text-xs md:text-sm bg-brand-dark/50 p-2 rounded">
                    <div className="flex items-center gap-2 text-gray-300">
                      <SafeIcon icon={p.icon} className={p.color} />
                      {p.label}
                    </div>
                    <span className="font-bold text-brand-accent">{p.pts}</span>
                  </li>
                ))}
              </ul>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}